import { ButtonAccent } from "components/Atoms/Button";
import { PlanningContext } from "PlanningContext/PlanningContext";
import React from "react";

const NewPlanning = () => {
  const planningContext = React.useContext(PlanningContext);

  return <ButtonAccent
    label={RESX.GeneralLabels.resxNew}
    onClick={() => { planningContext.openWithExistingOptions() }}
  />;
};

export default NewPlanning;
